import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import AuthLayout from '../../components/auth/AuthLayout'
import Loading from '../../components/Loading'
import { exchangeSSOCode } from '../../server/sso'
import { logLoginTime } from '../../server/usersData'
import { usePageTitle } from '../../utils/util'
import { useCompleteLogin } from '../../hooks/useCompleteLogin'

// Landing page of the SSO redirect: exchanges the one-time code from the backend for an
// Upstrive token and continues with the regular post-login flow.
const SSOCompleteScreen = () => {
    usePageTitle(`Upstrive Education - Login`)
    const history = useHistory()
    const { t } = useTranslation()
    const completeLogin = useCompleteLogin()
    const started = useRef(false)

    useEffect(() => {
        if (started.current) return
        started.current = true

        const code = new URLSearchParams(window.location.search).get('code')
        // The code is single use; keep it out of the history either way.
        window.history.replaceState(null, '', window.location.pathname)
        if (!code) {
            history.replace('/login?sso_error=invalid_code')
            return
        }

        const finish = async () => {
            const startTime = Date.now()
            const resp = await exchangeSSOCode(code)
            logLoginTime({
                start_time: startTime,
                end_time: Date.now(),
                device: 'desktop',
                success: resp.status === 200,
                user_id: resp?.data?.id,
                email: resp?.data?.email,
                serverError: 500 <= resp.status && resp.status < 599,
            })
            if (resp.status === 200) {
                await completeLogin(resp.data)
            } else {
                history.replace(`/login?sso_error=${encodeURIComponent(resp?.data?.error || 'server_error')}`)
            }
        }
        finish()
    }, [])

    return (
        <AuthLayout>
            <div className="flex flex-col items-center justify-center py-10">
                <Loading primaryColor="#FFF" secondaryColor="#FFF" size={50} stroke={4} />
                <p className="text-white text-lg mt-6">{t('ssoSigningIn')}</p>
            </div>
        </AuthLayout>
    )
}

export default SSOCompleteScreen
